import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  POST: 'BULK_PARENT_RM_ASSIGNMENT_POST',
  POST_SUCCESS: 'BULK_PARENT_RM_ASSIGNMENT_POST_SUCCESS',
  POST_FAILURE: 'BULK_PARENT_RM_ASSIGNMENT_POST_FAILURE',
};

export const post = actions.post(
  () => `${BASE_URL}/parents/rm-assignment/`,
  {
    PENDING: ACTIONS.POST,
    SUCCESS: ACTIONS.POST_SUCCESS,
    FAILURE: ACTIONS.POST_FAILURE,
  },
  {
    headers: {
      encType: 'multipart/form-data',
    },
  },
  true,
);
